import Vue from 'vue';
import InvoiceInfoCard from './cards/info/InvoiceInfoCard';
import InvoiceFacilityBillable from './cards/billable/InvoiceFacilityBillable';
import InvoiceProviderPayable from './cards/payable/InvoiceProviderPayable';
import { UserRoleEnum } from '@/enums/userRolesEnum';
import InvoiceSpecialNotes from './cards/special/InvoiceSpecialNotesCard';
import PotentialInvoiceNotesCard from './cards/potentialNotes/PotentialInvoiceNotesCard';
import PotentialInvoiceAttachmentsCard from './cards/potentialAttachments/PotentialInvoiceAttachmentsCard';
import PotentialInvoiceDetailsCard from './cards/potentialDetails/PotentialInvoiceDetailsCard';
import PotentialInvoiceTotalsCard from './cards/potentialTotals/PotentialInvoiceTotalsCard';
import InvoiceChecklistCard from './cards/checklist/InvoiceChecklistCard';

export default Vue.extend({
  name: 'PotentialInvoice',
  props: {
    'facilityId': { type: String },
    'specialtyId': { type: String },
    'invoiceDate': { type: String }
  },
  components: {
    InvoiceFacilityBillable,
    InvoiceProviderPayable,
    InvoiceInfoCard,
    InvoiceSpecialNotes,
    PotentialInvoiceNotesCard,
    PotentialInvoiceAttachmentsCard,
    PotentialInvoiceDetailsCard,
    PotentialInvoiceTotalsCard,
    InvoiceChecklistCard
  },
  data () {
    return {
      isAuthorized: false,
      invoiceInfo: null
    };
  },
  beforeMount: function () {
    this.isAuthorized = this.$store.getters['user/hasRole']([
      UserRoleEnum.MANAGER,
      UserRoleEnum.ACCOUNTANT
    ]);
  },
  methods: {
    invoiceInfoLoaded (invoiceInfo: any) {
      this.invoiceInfo = invoiceInfo;
      if (invoiceInfo && invoiceInfo.invoiceId > 0) {
        this.$router.push({ name: 'Invoice', params: { invoiceId: invoiceInfo.invoiceId }});
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/invoice/PotentialInvoice.ts